import React, { useState } from 'react';
import './LandingPage.css';
import { useAuth } from './auth';
import news1 from './news/news1.md.js';
import news2 from './news/news2.md.js';
import news3 from './news/news3.md.js';
import news4 from './news/news4.md.js';
import article01 from './news/article01.md.js';
import article02 from './news/article02.md.js';
import article03 from './news/article03.md.js';
import article04 from './news/article04.md.js';

const IconRenderer = ({iconName}) => {
   return <>No image for {iconName}</>;
};

const features = [
  {
    key: 'reminders',
    title: 'SweatText SMS Reminders',
    description: 'Automate client reminders and boost engagement with easy SMS scheduling.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/sweattext_icon_nopad.png',
    route: '/tools/reminders/step1',
    button: 'Try SweatText',
    type: 'Tool',
  },
  {
    key: 'timer',
    title: 'Basic Countdown Timer',
    description: 'Simple, effective timer for workouts and rest intervals.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/timer_icon.png',
    route: '/tools/timer',
    button: 'Open Timer',
    type: 'Tool',
  },
  {
    key: 'onerepmax',
    title: 'One Rep Max Estimator',
    description: 'Estimate your max lift and plan progressive overload.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/onerepmax_icon.png',
    route: '/tools/onerepmax',
    button: 'Estimate Max',
    type: 'Tool',
  },
  {
    key: 'proteinintake',
    title: 'Protein Intake Calculator',
    description: 'Estimate a typical protein intake based on body weight and activity level.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/proteinintake_icon.png',
    route: '/tools/proteinintake',
    button: 'Check it out!',
    type: 'Tool',
  },
  {
    key: 'fittracker',
    title: 'FitTracker',
    description: 'Track goals, progress, and client profiles in a demo environment.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fittracker_icon.png',
    route: '/clients/example/dashboard',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'scheduler',
    title: 'Session Scheduling Tool',
    description: 'Organize sessions and manage availability with ease.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/scheduler_icon.png',
    route: '/clients/example/schedulingavailability',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'workoutprogramming',
    title: 'Workout Programming',
    description: 'Build and browse workout routines and exercises.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/programmer_icon.png',
    route: '/workoutlibrary',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'messages',
    title: 'Messaging',
    description: 'Communicate securely with clients and trainers.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/messages_icon.png',
    route: '/messages',
    button: 'View Demo',
    type: 'Demo',
  },
  {
    key: 'payments',
    title: 'Payments',
    description: 'Track and manage payments for sessions and services.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/payments_icon.png',
    route: '/clients/example/payments',
    button: 'View Demo',
    type: 'Demo',
  },
];

const actionFeatures = [
  {
    key: 'login',
    title: 'Member Login / Signup',
    description: 'Access your dashboard, manage clients, and use all PTC tools.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_1.png',
    button: 'Log In',
    onClick: () => window.location.href = '/login',
    show: (user) => !user,
    type: '',
  },
  {
    key: 'earlyaccessform',
    title: '📝 Early Access Form',
    description: 'Fill out the form to join our early access program.',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_3.png',
    button: null,
    onClick: null,
    show: (user, showForm) => showForm,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfVkiPJ4SvH6L40Bklh71c_MjlF8sLM1RnZr87zafVPcNNjVg/viewform?embedded=true',
    type: '',
  },
  {
    key: 'questionnaire',
    title: 'Optional Questionnaire',
    description: 'Help us improve by sharing your feedback. All questions are optional!',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_2.png',
    button: 'Complete Questionnaire',
    link: 'https://forms.gle/gSaV7owzrzKwEkJJ9',
    show: () => true,
    type: '',
  },
  {
    key: 'instagram',
    title: 'Follow Us on Instagram',
    description: 'Stay updated and join our community on Instagram!',
    image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/icons/ptc/qr_without_border.png',
    button: 'Follow on Instagram',
    link: 'https://www.instagram.com/thepersonaltrainersclub/',
    qr: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/qr_without_border.png',
    show: () => true,
    type: '',
  },
];

const NEWS_IMAGE_URL = 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_1.png';

const newsArticles = [
  { markdown: article04, 
    url: '/articles/4', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/proteinintake_icon.png' },
  { markdown: news4, 
    url: '/news/4', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_1.png' },
  { markdown: article03, 
    url: '/articles/3', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_2.png' },
  { markdown: article02, 
    url: '/articles/2', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_3.png' },
  { markdown: article01, 
    url: '/articles/1', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_4.png' },
  { markdown: news3, 
    url: '/news/3', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_5.png' },
  { markdown: news2, 
    url: '/news/2', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_6.png' },
  { markdown: news1, 
    url: '/news/1', 
    imageUrl: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_7.png' },
];


const cardVariants = {
    offscreen: {
        y: 300,
    },
    onscreen: {
        y: 50,
        rotate: -10,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
        },
    },
};

function Row({ children }) {
  return <div className="feature-card-row"
    style={{display:'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        width: "100%",
    }}>{children}</div>;
}

function Col({ children }) {
  return <div className="feature-card-col"
    style={{display:'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        flex: 1,
        minWidth: 0
    }}
    >{children}</div>;
}

function FeatureCard({
  title,
  description,
  image,
  iconName,
  button,
  onClick,
  link,
  form,
  qr,
  type,
  badge,
  children,
  articleText,
  articleUrl,
  imageUrl,
  mutedText,
}) {

  const titleWithoutHashtags = title ? title.replace(/#/g, '') : null;

  const trimmedArticleText1 = articleText && articleText.length > 200
    ? articleText.substring(0, 200) + '...'
    : articleText;

  // Get the date - it is the second line.
  const articleDate = articleText ? articleText.split('\n')[1] : null;

  const articleDateWithNoAsterisks = articleDate ? articleDate.replace(/\*/g, '') : null;

  // REmove the first two lines since it is the title 
  const trimmedArticleText2 = articleText && articleText.length > 200
    ? articleText.split('\n').slice(2).join('\n').substring(0, 200) + '...'
    : articleText;

  // Also remove all hashtags `#` no matter how many 
  const trimmedArticleText = trimmedArticleText2 ? trimmedArticleText2.replace(/#/g, '') : null;  

  return (
    <div className={`feature-card`}>
      <Row>
        <Col>
          {!iconName && !qr && (
            <div
              className="feature-card-cover"
              style={{
                backgroundImage: `url(${image || imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
              role="img"
              aria-label={titleWithoutHashtags}
            >
              <div className="feature-card-cover-overlay" />
              {/* <div className="feature-card-badge" title={titleWithoutHashtags}>
                {badge || (titleWithoutHashtags && titleWithoutHashtags.split(' ')[0])}
              </div> */}
            </div>
          )}
          {iconName && <IconRenderer iconName={iconName} />}
          {qr && (
            <div style={{ marginTop: 16 }}>
              <img
                src={qr}

                width="100%"
                alt="QR Code"
                className="landing-page-qr-code"
              />
            </div>
          )}
        </Col>
        <Col>
          {type && (
            <div className="feature-card-type">{type.toUpperCase()}</div>
          )}
          <div className="feature-card-body">
            <div className="feature-card-title">{titleWithoutHashtags}</div>
            <div>
              {articleDate && (
                <strong>{articleDateWithNoAsterisks}</strong>
              )}
            </div>
            <div className="feature-card-description">
              {description}
              {articleText && (
                <div style={{ marginTop: 8 }}>
                  <div className="news-preview-text">{trimmedArticleText}</div>
                </div>
              )}
            </div>
            {children}
            {form ? (null) : link ? (
              <a
                href={link || articleUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                className="feature-card-button"
              >
                {button || 'Read More'}
              </a>
            ) : button ? (
              <button
                className="feature-card-button"
                onClick={onClick}
              >
                {button}
              </button>
            ) : null}
            {mutedText && (
              <div className="landing-page-muted-text">{mutedText}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

const VIDEO_DEMO_URL = 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/ptc_explainer_draft.MOV';

export function LandingPage() {
  const [showForm, setShowForm] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { user } = useAuth();

  // Add Video Demo button to features
  const featuresWithVideoDemo = [
    ...features,
    {
      key: 'videodemo',
      title: 'Video Demo',
      description: 'Watch a quick explainer video about PTC features.',
      image: 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/fit_1.png',
      button: 'Video Demo',
      onClick: () => setShowVideoModal(true),
      type: 'Demo',
    },
  ];

  return (
    <div className="landing-page-container fogged-card">
      <h1 className="landing-page-title">Welcome to The Personal Trainers Club!</h1>
      <p className="landing-page-description">
        A collection of tools for trainers to manage clients, build workouts, and grow your business.<br />
      </p>
      {/* Responsive grid of feature cards */}
      <div className="landing-page-features-grid">
        {featuresWithVideoDemo.map((feature) => (
          <FeatureCard
            key={feature.key}
            title={feature.title}
            description={feature.description}
            image={feature.image}
            iconName={feature.iconName}
            button={feature.button}
            onClick={feature.onClick ? feature.onClick : () => (window.location.href = feature.route)}
            type={feature.type}
            badge={feature.title.split(' ')[0]}
          />
        ))}
      </div>

      {/* Full-feature style action cards */}
      <div className="landing-page-features-grid">
        {actionFeatures.map((feature) => {
          if (!feature.show(user, showForm)) return null;
          return (
            <FeatureCard
              key={feature.key}
              title={feature.title}
              description={feature.description}
              image={feature.image}
              button={feature.button}
              onClick={
                feature.form
                  ? null
                  : feature.key === 'earlyaccessform'
                  ? () => setShowForm(true)
                  : feature.onClick
              }
              link={feature.link}
              form={feature.form}
              iconName={feature.iconName}
              qr={feature.qr}
              type={feature.type}
              mutedText={feature.key === 'questionnaire' ? 'All questions are optional!' : null}
            />
          );
        })}

        {/* News articles as landing page style cards */}
        {newsArticles.map((article, idx) => (
          <FeatureCard
            key={idx}
            title={article.markdown.split('\n')[0].replace('#', '').substring(0, 60) + (article.markdown.length > 60 ? '...' : '')}
            description=""
            imageUrl={article.imageUrl}
            articleText={article.markdown}
            articleUrl={article.url}
            link={article.url}
            type="Article"
            button="Read More"
            badge="📰"
          />
        ))}
      </div>

      {/* Video Demo Modal */}
      {showVideoModal && (
        <div className="video-demo-modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 8,
            padding: 24,
            maxWidth: 600,
            width: '90%',
            position: 'relative',
            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
          }}>
            <button
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: '#eee',
                border: 'none',
                borderRadius: 4,
                padding: '4px 8px',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
              onClick={() => setShowVideoModal(false)}
            >
              Close
            </button>
            <video
              src={VIDEO_DEMO_URL}
              controls
              style={{ width: '100%', borderRadius: 8 }}
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
}